var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-avatar",style:(_vm.styleList)},[(_vm.showTitle)?_c('div',{staticClass:"title"},[_vm._v("\n    "+_vm._s(_vm.title.trim().slice(0,1))+"\n  ")]):_c('img',{staticClass:"avatar",attrs:{"src":_vm.prefixImgUrl},on:{"error":_vm.errorImg}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28fe7c5a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/components/BaseAvatar.vue
// module id = null
// module chunks = 